<template>
	<v-layout>
		<v-flex xs12 data-cy="amountItemSubproduct" :id="group.id">
			<v-container v-bind="{ [`grid-list-sm`]: true }" fluid>
				<v-layout row wrap class="addon-wrapper">
					<template v-if="isBM100 && hasGroupUpsellProducts()">
						<template v-if="newAddonsFlow && !isSingleMenuPage">
							<div class="upsell-wrapper spacing-box product-catalog-carousel">
								<div class="carousel-gradient-start"></div>
								<div class="carousel-gradient-end"></div>
								<carousel
									:per-page="2.5"
									:mouse-drag="true"
									:scrollPerPage="false"
									:center-mode="true"
									:navigationEnabled="true"
									:paginationEnabled="false"
									navigationNextLabel="<v-icon class='v-icon material-icons theme--light'>chevron_right</v-icon>"
									navigationPrevLabel="<v-icon class='v-icon material-icons theme--light'>chevron_left</v-icon>">
									<slide v-for="item in getGroupProducts().slice(0, addonsLimit)" :key="item.id" v-if="isUpsellProduct(item)">
										<v-flex
											class="add-remove-flex amount extra-flex"
											:class="getItemClasses(item)"
										>
											<amount-item
												:group="group"
												:productSelection="productSelection"
												:index="index"
												:changeGroupProductSelection="changeGroupProductSelection"
												:changeSubGroupProductSelection="changeSubGroupProductSelection"
												:isMenu="isMenu"
												:product="item"
												:showPrice="showPrice"
												:mainGroup="mainGroup"
												:subProduct="subProduct"
												:additionsProductNotSelected="additionsProductNotSelected"
												:isNoThanksSelected="isNoThanksSelected"
												:isGroupHighlighted="isGroupHighlighted"
												:hasGroupUpsellProducts="hasGroupUpsellProducts"
												:rootProduct="rootProduct"
											>
											</amount-item>
										</v-flex>
									</slide>
								</carousel>
							</div>
							<v-flex
								v-for="item in getGroupProducts().slice(0, addonsLimit)"
								:key="item.id"
								class="add-remove-flex amount extra-flex"
								:class="getItemClasses(item)"
								v-if="!isUpsellProduct(item)"
							>
								<amount-item
									:group="group"
									:productSelection="productSelection"
									:index="index"
									:changeGroupProductSelection="changeGroupProductSelection"
									:changeSubGroupProductSelection="changeSubGroupProductSelection"
									:isMenu="isMenu"
									:product="item"
									:showPrice="showPrice"
									:mainGroup="mainGroup"
									:subProduct="subProduct"
									:additionsProductNotSelected="additionsProductNotSelected"
									:isNoThanksSelected="isNoThanksSelected"
									:isGroupHighlighted="isGroupHighlighted"
									:hasGroupUpsellProducts="hasGroupUpsellProducts"
									:rootProduct="rootProduct"
								>
								</amount-item>
							</v-flex>
						</template>
						<template v-else-if="isSingleMenuPage">
							<v-flex
								v-for="item in getGroupProducts()"
								:key="item.id"
								class="add-remove-flex amount extra-flex"
								:class="getItemClasses(item)"
							>
								<amount-item
									:group="group"
									:productSelection="productSelection"
									:index="index"
									:changeGroupProductSelection="changeGroupProductSelection"
									:changeSubGroupProductSelection="changeSubGroupProductSelection"
									:isMenu="isMenu"
									:product="item"
									:showPrice="showPrice"
									:mainGroup="mainGroup"
									:subProduct="subProduct"
									:additionsProductNotSelected="additionsProductNotSelected"
									:isNoThanksSelected="isNoThanksSelected"
									:isGroupHighlighted="isGroupHighlighted"
									:hasGroupUpsellProducts="hasGroupUpsellProducts"
									:rootProduct="rootProduct"
									:crossSellProductToHighlight="crossSellProductToHighlight"
								>
								</amount-item>
							</v-flex>
						</template>
						<template v-else>
							<v-flex
								v-for="item in getGroupProducts().slice(0, addonsLimit)"
								:key="item.id"
								class="add-remove-flex amount extra-flex"
								:class="getItemClasses(item)"
							>
								<amount-item
									:group="group"
									:productSelection="productSelection"
									:index="index"
									:changeGroupProductSelection="changeGroupProductSelection"
									:changeSubGroupProductSelection="changeSubGroupProductSelection"
									:isMenu="isMenu"
									:product="item"
									:showPrice="showPrice"
									:mainGroup="mainGroup"
									:subProduct="subProduct"
									:additionsProductNotSelected="additionsProductNotSelected"
									:isNoThanksSelected="isNoThanksSelected"
									:isGroupHighlighted="isGroupHighlighted"
									:hasGroupUpsellProducts="hasGroupUpsellProducts"
									:rootProduct="rootProduct"
									:crossSellProductToHighlight="crossSellProductToHighlight"
								>
								</amount-item>
							</v-flex>
						</template>

						<v-expansion-panel v-if="isExtraAddOnsShown && !isSingleMenuPage" class="extra-add-ons">
							<v-expansion-panel-content>
								<template v-slot:header>
									<div>{{ $t("shopComponents.gt3.detailsTemplates_steps.detailsGroups.extraOptionalItems") }}</div>
								</template>
								<v-layout row wrap>
									<v-flex
										v-for="item in getGroupProducts().slice(addonsLimit)"
										:key="item.id"
										class="add-remove-flex amount extra-flex"
										:class="getItemClasses(item)"
									>
										<amount-item
											:group="group"
											:productSelection="productSelection"
											:index="index"
											:changeGroupProductSelection="changeGroupProductSelection"
											:changeSubGroupProductSelection="changeSubGroupProductSelection"
											:isMenu="isMenu"
											:product="item"
											:showPrice="showPrice"
											:mainGroup="mainGroup"
											:subProduct="subProduct"
											:additionsProductNotSelected="additionsProductNotSelected"
											:isNoThanksSelected="isNoThanksSelected"
											:isGroupHighlighted="isGroupHighlighted"
											:hasGroupUpsellProducts="hasGroupUpsellProducts"
											:rootProduct="rootProduct"
											:crossSellProductToHighlight="crossSellProductToHighlight"
										>
										</amount-item>
									</v-flex>
								</v-layout>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</template>
					<template v-else>
						<v-flex
							v-for="item in getGroupProducts()"
							:key="item.id"
							class="add-remove-flex amount extra-flex"
							:class="getItemClasses(item)"
						>
							<amount-item
								:group="group"
								:productSelection="productSelection"
								:index="index"
								:changeGroupProductSelection="changeGroupProductSelection"
								:changeSubGroupProductSelection="changeSubGroupProductSelection"
								:isMenu="isMenu"
								:product="item"
								:showPrice="showPrice"
								:mainGroup="mainGroup"
								:subProduct="subProduct"
								:additionsProductNotSelected="additionsProductNotSelected"
								:isNoThanksSelected="isNoThanksSelected"
								:isGroupHighlighted="isGroupHighlighted"
								:hasGroupUpsellProducts="hasGroupUpsellProducts"
								:rootProduct="rootProduct"
								:isSingleMenuPage="isSingleMenuPage"
								:crossSellProductToHighlight="crossSellProductToHighlight"
							>
							</amount-item>
						</v-flex>
					</template>
					<div
						class="addition-selection-text"
						v-if="additionsProductNotSelected && isGroupHighlighted && hasGroupUpsellProducts()"
					>
						{{$t("shopComponents.gt3.productCatalog.productGroupCheckBoxGrid.text")}}
					</div>
				</v-layout>
			</v-container>
		</v-flex>
	</v-layout>
</template>

<script>
	import appConfig, {channelEnum} from "../../../../../appconfig";
	import* as Util from "../../../../../libraries/utils";
	import {canBePickedUp, getBackImages, imageLoader} from "../../../../../libraries/utils";
	import amountItemMixin from "../../../../../mixins/amountItemMixin";
	import * as mutationTypes from "../../../../../store/mutation-types";
	import {mapGetters} from "vuex";
	import {isNoThanksProduct, isNoThanksProductId} from "../../../../../helper/ProductSelectionHelper";
	import {
		isCrossSellHighlightedItem,
		productHasCustomLabel,
		productHasDiscountLabel, productHasDiscountLabelWithLongText
	} from "../../../../../helper/ProductHelper";
	import LabelComponent from "../../../../UtilityComponents/Label";
	import _ from "lodash";
	import addOnMixin from "../../../../../mixins/addOn.mixin";
	import {Carousel, Slide} from "vue-carousel/src";
	import {savePickedBadge} from "../../../../../helper/RcmProductBadgeHelper";
	export default {
		name: "AmountGroup-gt3",
		props: ["group", "changeGroupProductSelection", "productSelection", "index", "changeSubGroupProductSelection", "showPrice",
			"isMenu", "mainGroup", "subProduct", "additionsProductNotSelected", "rootProduct", "isSingleMenuPage", "crossSellProductToHighlight"],
		mixins: [addOnMixin],
		mounted() {
			const self = this;
			self.$store.commit(mutationTypes.HIGHLIGHT_GROUPS_WITH_MISSING_SELECTION, []);
			self.$nextTick(() => {
				window.addEventListener("resize", this.onResize);
			});
		},
		components: {
			LabelComponent, Carousel, Slide,
			"amount-item": {
				props: ["productSelection", "group", "index", "changeGroupProductSelection", "product", "changeSubGroupProductSelection", "showPrice",
					"isMenu", "mainGroup", "subProduct", "additionsProductNotSelected", "isNoThanksSelected",
					"isGroupHighlighted", "hasGroupUpsellProducts", "rootProduct", "isSingleMenuPage", "crossSellProductToHighlight"],
				mixins: [amountItemMixin],
				template: `
					<div
							class="amount-wrapper"
							:class="{'upsell-height-fix': isUpsellProduct(product), 'upsell-no-thanks-height-fix': isNoThanks && hasGroupUpsellProducts(), 'product-crosssel-highlight-border': isCrossSellHighlightedItemFn(crossSellProductToHighlight, product.id) }"
							:data-cy="product.name"
					>
						<div v-if="isCrossSellHighlightedItemFn(crossSellProductToHighlight, product.id)"
								 class="width-100 product-crosssel-highlight-box"
						>
							{{ crossSellProductToHighlight.highlightProductLabel | translate("crossSellProductToHighlight." + crossSellProductToHighlight.id + ".options.highlightProductLabel") }}
						</div>
					<div class="sub-product-wrapper"
							 :class="{'no-thanks-selected': isNoThanksSelected && isNoThanks, 'no-thanks': isNoThanks, 'addition-not-selected': isGroupHighlighted, 'upsell-height-fix': isUpsellProduct(product), 'upsell-no-thanks-height-fix' : isNoThanks && hasGroupUpsellProducts()}"
							 @click.stop="addQuantity(false)">
						<v-badge
							v-if="productHasDiscountLabelFn(product)"
							class="family-discount-label-wrapper" :class="{'family-discount-label-wrapper-kiosk' : isKioskChannel, 'family-discount-label-long-text':  productHasDiscountLabelWithLongTextFn(product)}"
						>
							{{ product.discount.options.productLabel | translate("priceRule." + product.discount.discountId + ".productLabel") }}
						</v-badge>
						<div class="sub-product-content" style="color: #FFFFFF">
							<div class="product-box dimensions-fix"></div>
							<v-img v-if="isUpsellProduct(product) || (isNoThanks && hasGroupUpsellProducts)" :src="backImg[0]" maintain-aspect class="image-box" :class="{'upsell-no-thanks-height-fix' : (isNoThanks && hasGroupUpsellProducts()) }" :alt="product.displayName">
								<div class="bottom-wrapper" v-if="isNoThanks && hasGroupUpsellProducts()">
									<div class="subproduct-burger-checkbox" style="padding: 0 16px 17px 24px">
										<v-checkbox :input-value="isNoThanksSelected" @click.prevent="doNothing" class="no-thanks-checkbox"/>
									</div>
									<div class="subproduct-name">
										{{ isNoThanks
										? $translate(product.name, "shopComponents.gt3.productCatalog.productCatalogList.noThanks")
										: product.name | translate("product." + product.id + ".name")
										}}
									</div>
								</div>
							</v-img>
							<v-list-tile-avatar v-else-if="backImg.length > 0 && !hasGroupUpsellProducts() && (!isSingleMenuPage || (isSingleMenuPage && isMenu))" :tile="true">
								<template v-if="productHasCustomLabelFn(product)">
									<LabelComponent
										:product="product"
										parentComponent="switches"
									>
										<img :src="backImg[0]" :alt="product.displayName"/>
									</LabelComponent>
								</template>
								<template v-else>
									<img :src="backImg[0]" :alt="product.displayName"/>
								</template>
							</v-list-tile-avatar>
							<div class="sunset-wrapper" v-if="!(hasGroupUpsellProducts() && isNoThanks)" :class="{'no-image': !this.product.imageLinks.length}">
								<div class="subproduct-name">
									{{ isNoThanks
										? $translate(product.name, "shopComponents.gt3.productCatalog.productCatalogList.noThanks")
										: product.name | translate("product." + product.id + ".name")
									}}
								</div>
								<div class="subproduct-price" v-if="!isNoThanks">
									<template v-if="showPrice && !isNoThanksSelected">
										<span :class="{'old-price': shouldShowDiscountedPrice}">+{{ subproductPrice }}</span>&nbsp;
										<span v-if="shouldShowDiscountedPrice">+{{ discountPrice }}</span>
									</template>
								</div>
								<div v-else-if="!hasGroupUpsellProducts()" class="subproduct-burger-checkbox">
									<v-checkbox :input-value="isNoThanksSelected" @click.prevent="doNothing" class="no-thanks-checkbox"/>
								</div>
							</div>
						</div>
						<div class="add-remove-btn-wrapper" v-if="!isNoThanks">
							<v-btn v-if="!cartQuantityDialogShown" flat class="plus-button"
										 v-bind:class="{'add-btn-selected-color' : subProductQuantity !== 0}"
										 @click.stop="addQuantity(true)"
										 :ripple="false">
								<div class="add-image" v-if="subProductQuantity === 0">

								</div>
								<div v-else>{{ subProductQuantity }}</div>
							</v-btn>
							<div v-else :key="product.id" @click.stop class="add-remove-btn">
								<div data-cy="addRemoveBtns">
									<v-btn
										flat
										@click.stop="removeQuantity"
										class="remove-button"
										:ripple="false"
										data-gtm-remove-from-cart="true">
										<div class="remove-image">

										</div>
									</v-btn>
									<v-chip label class="add-quantity">{{ subProductQuantity }}</v-chip>
									<v-btn
										flat
										@click.stop="addQuantity"
										class="add-button"
										:ripple="false"
										data-cy="plusBtn"
										data-gtm-add-to-cart="true">
										<div class="add-image">

										</div>
									</v-btn>
								</div>
							</div>
						</div>
					</div>
					</div>`,
				components: {LabelComponent},
				data() {
					return {
						cartQuantityDialogShown: false,
						productSelectionState: {...this.productSelection}// productSelection prop will be mutated
					};
				},
				computed: {
					...mapGetters([
						"groupsWithMissingSelections",
						"featureToggles",
						"globalSelectedShop",
						"productCatalog"
					]),
					subProductQuantity() {
						const self = this;

						const groupSelection = self.productSelectionState.groups.find(group => group.groupId === self.group.id);
						if(groupSelection) {
							const existingProduct = groupSelection.selectedProducts.find(product => product.productId === self.product.id);
							if(existingProduct) {
								return existingProduct.quantity;
							} else {
								return 0;
							}
						} else {
							const subProductGroupSelection = self.productSelectionState.groups[0].selectedProducts[0].groups.find(group => group.groupId === self.group.id);
							if(subProductGroupSelection) {
								const existingProduct = subProductGroupSelection.selectedProducts.find(product => product.productId === self.product.id);
								if(existingProduct) {
									return existingProduct.quantity;
								} else {
									return 0;
								}
							} else {
								return 0;
							}
						}
					},
					backImg() {
						return getBackImages(this.product, this.isKioskChannel);
					},
					isKioskChannel() {
						return appConfig.channelAlias() === channelEnum.kiosk;
					}
				},
				methods: {
					isUpsellProduct(p) {
						return _.get(p, ["productGroupDetails", this.group.id, "additionalDetails", "upsellProduct"]);
					},
					isCrossSellHighlightedItemFn(crossSellProductToHighlight, productId) {
						return isCrossSellHighlightedItem(crossSellProductToHighlight, productId);
					},
					productHasDiscountLabelFn(product) {
						return productHasDiscountLabel(product);
					},
					productHasCustomLabelFn(product) {
						return productHasCustomLabel(product);
					},
					productHasDiscountLabelWithLongTextFn(product) {
						return productHasDiscountLabelWithLongText(product);
					},
					addQuantity(isBtn) {
						const self = this;
						if(self.cartQuantityDialogShown || !isBtn || self.subProductQuantity === 0) {
							if(!(self.isNoThanks && self.isNoThanksSelected)) {
								self.changeGroupProductSelection(self.group, self.product.id, self.subProductQuantity + 1);
							}
							if(self.isGroupWithMandatorySelections) {
								self.manageMandatoryProductSelections();
							}
						}
						self.$nextTick(() => {
							if (self.isGroupHighlighted && self.isGroupWithMandatorySelections) {
								const groupIds = self.groupsWithMissingSelections[self.index].map(group => group.id);
								self.$store.commit(mutationTypes.HIGHLIGHT_GROUPS_WITH_MISSING_SELECTION, groupIds);
							}
							self.cartQuantityDialogShown = true;
							self.resetTimeout();
						});
						savePickedBadge({product: self.product});
					},
					removeQuantity() {
						const self = this;
						self.changeGroupProductSelection(self.group, self.product.id, self.subProductQuantity - 1);
						self.cartQuantityDialogShown = true;
						self.resetTimeout();
					},
					listTileImage(group) {
						const self = this;
						if (group.options.staticImage) {
							return imageLoader("8T5", group.options.staticImage, null, "dynamic", true);
						}
						// zero index is hard coded because displayed image for group makes sense if only 1 product is selected
						const selectedProductId = self.productSelectionState.groups.find(grp => grp.groupId === group.id).selectedProducts[0];
						return self.backImg(self.productCatalog.getProduct(selectedProductId, false))[0];
					},
					getImageUrl(product) {
						return product.imageLinks.map(imgUrl => Util.imageLoader("8T5", imgUrl, undefined, "dynamic", true));
					}
				}
			}
		},
		methods: {
			getItemClasses(item) {
				if(this.isSingleMenuPage) {
					return "xs12";
				}
				return !(this.isUpsellProduct(item) || (this.isNoThanksProduct(item) && this.hasGroupUpsellProducts()))
					? this.windowWidth > 1024 ? "xs4" : "xs6" : this.isUpsellProduct(item)
						? "upsell-item-wrapper" : this.isNoThanksProduct(item) && this.hasGroupUpsellProducts()
							? "upsell-no-thanks-item-wrapper" : "";
			},
			hasGroupUpsellProducts() {
				return this.group.products.filter(product => product.isActive).some(p => this.isUpsellProduct(p));
			},
			getGroupProducts(){

				const groupProducts = this.group.products.filter(product => {
					const isProductAvailable = canBePickedUp(
						product,
						this.productCatalog,
						this.$store.getters.cachedPickupRules,
						this.globalSelectedShop.id
					);
					if(this.newAddonsFlow) {
						return isProductAvailable && !product.options.isNoThanks;
					}
					return isProductAvailable;
				});
				const filteredProducts = this.hasGroupUpsellProducts()
					? groupProducts.map(p => isNoThanksProduct(p) ? {...p, imageLinks: ["123T144/nej-tak-v1-cropped.png", "123T144/nej-tak-v1-cropped_thumb.png"]} : p)
					: groupProducts;
				if (this.crossSellProductToHighlight && this.crossSellProductToHighlight.highlightProductId) {
					const highlightProductId = this.crossSellProductToHighlight.highlightProductId;
					const highlightProductIndex = filteredProducts.findIndex(product => product.id === highlightProductId);
					if (highlightProductIndex !== -1) {
						const highlightProduct = filteredProducts.splice(highlightProductIndex, 1)[0];
						filteredProducts.splice(1, 0, highlightProduct);
					}
				}
				return filteredProducts;
			},
			isNoThanksProduct,
			isUpsellProduct(p) {
				return _.get(p, ["productGroupDetails", this.group.id, "additionalDetails", "upsellProduct"]);
			},
			onResize() {
				this.windowWidth = window.innerWidth;
			}
		},
		computed: {
			...mapGetters(["highlightedGroupsWithMissingSelection", "productCatalog", "tenantSettings"]),
			isGroupHighlighted() {
				const self = this;
				return self.highlightedGroupsWithMissingSelection.find(g => g === self.group.id) !== undefined;
			},
			isNoThanksSelected() {
				const self = this;
				const mainProductSelection = self.subProduct ? self.productSelection.groups.find(g => g.groupId === self.mainGroup.id).selectedProducts[0] : self.productSelection;
				const group = mainProductSelection.groups.find(g => g.groupId === self.group.id);
				return group.selectedProducts.map(sp => isNoThanksProductId(sp.productId)).includes(true);
			},
			isBM100() {
				return appConfig.isBM100();
			}
		},
		data() {
			return {
				windowWidth: window.innerWidth
			};
		}
	};
</script>
<style scoped lang="scss">
	.flex-40 {
		flex-basis: 40%!important;
	}
	.flex {
		text-align: center;
		position: relative;
	}
	.container.grid-list-sm .layout .flex {
		z-index: 1;
		padding: 0;
	}
	.container {
		padding: 0;
		.addon-wrapper{
			margin: 0 -7.5px 0 -7.5px !important;
			padding: 0;
			.flex{
				padding-left: 7.5px !important;
				padding-right: 7.5px !important;
				margin-bottom: 15px;
			}
		}
	}
	.add-remove-flex {
		z-index: 100;
		border-bottom: 1px solid rgba(0,0,0,.12) !important;
		padding: 8px 10px 8px 2px !important;
	}
	.add-remove-flex{
		height: 110px;
		.sub-product-wrapper {
			display: inline-block;
			position: absolute;
			.subproduct-name {
				font-size: 22px;
			}
			.subproduct-price {
				font-size: 16px;
				line-height: 0.5;
			}
		}
		.v-btn {
			height: 44px;
			width: 44px;
			min-width: 44px;
			-webkit-border-radius: 4px;
			-moz-border-radius: 4px;
			border-radius: 4px;
			background-color: #ffffff;
			box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);

			.v-btn__content {
				padding: 0 12px;
			}

			.v-icon {
				font-weight: bold;
			}
		}

		.add-button, .plus-button {
			margin: 6px 8px;
			transition: none !important;
			background-color: #ffc627 !important;
			color: #231F20;
			border: 1px solid #ffc627;

			.add-image {
				position: relative;
				top: 1px;
			}

			.v-btn__content {
				padding: 2px 0 0 0 !important;
				transition: none !important;
			}

			:active {
				background-color: #000000 !important;

				#S30-Open-Large-Menu {
					fill: #ffc627 !important;
				}
			}
		}

		.remove-button {
			transition: none !important;
			background-color: #d8d8d8 !important;
			color: #231f20;

			.remove-image {
				position: relative;
				top: -3px;
			}

			.v-btn__content {
				padding: 0 !important;
				transition: none !important;
			}

			:active {
				background-color: #494949 !important;

				#S30-Open-Large-Menu {
					fill: #ffffff !important;
				}
			}
		}

		.add-btn-selected-color {
			background-color: #ffc627 !important;
			color: #231F20;
			font-size: 30px;
			border: 1px solid #ffc627;
		}

		.add-btn-selected-color:active {
			color: #ffc627;
			border: 1px solid #000000;
		}

		img {
			width: 100%;
			height: 100%;
			pointer-events: none;
			-webkit-touch-callout: none;
			touch-action: none;
			-webkit-user-select: none;
			user-select: none;
		}

		.add-remove-btn-wrapper {
			width: 80px;
			text-align: right;
			display: inline-block;
			float: right;

			.add-remove-btn {
				width: 204px;
				position: relative;
				right: 120px;
				text-align: center;
				background-color: #fff;
				-webkit-border-radius: 6px;
				-moz-border-radius: 6px;
				border-radius: 6px;
				box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
				padding: 0;

				.v-chip {
					background-color: #ffffff;
					font-weight: bold;
					font-size: 30px;
					min-width: 60px;
					text-align: center;
					color: #231F20;
					margin: 4px 6px;

					.v-chip__content {
						margin: 0 auto;
					}
				}

				.v-btn:last-child {
					background-color: #ffc627 !important;
					color: #231F20;
				}

				.v-btn:first-child {
					background-color: #d8d8d8 !important;
					color: #231F20;
				}
			}
		}
	}
	.upsell-item-wrapper {
		width: 40%!important;
		height: auto!important;
		flex: 0 1 auto;
		flex-basis: 40% !important;
	}
	.upsell-no-thanks-item-wrapper {
		width: 20%!important;
		height: auto!important;
		flex: 0 1 auto;
		flex-basis: 20% !important;
	}
	.addition-selection-text {
		position: absolute;
		font-size: 16px;
		padding-top: 4px;
		color: #FFD800;
		padding-left: 22px;
		bottom: 7px;
	}
	.v-expansion-panel.extra-add-ons {
		margin-top: 40px;
		margin-bottom: 10px;
		.v-expansion-panel__container {
			background-color: #000;
			/deep/.v-expansion-panel__header {
				background-color: #161616;
				margin: 0 20px;
				height: 42px;
				line-height: 42px;
				font-size: 20px;
				color: #9b9b9b;
				font-family: Dispatch;
				border-radius: 3px;
				min-height: 42px;
				font-weight: bold;
				text-transform: uppercase;
			}
			/deep/.v-expansion-panel__body {
				margin-top: 20px;
			}
			/deep/.v-expansion-panel__header__icon .v-icon {
				color: #9b9b9b;
			}
		}
	}
	.product-catalog-carousel {
		position: relative;
		margin: 20px;
		width: 100%;
		.upsell-item-wrapper {
			width: 100% !important;
			height: 100% !important;
		}
		.add-remove-flex.flex {
			max-width: 100% !important;
		}
		/deep/ .VueCarousel-navigation-button {
			border: 3px solid #FFFFFF;
			border-radius: 50%;
			width: 44px;
			height: 44px;
			.v-icon {
				color: #FFFFFF;
				font-size: 30px;
				width: 20px;
				height: 20px;
			}
		}
		.carousel-gradient-start {
			width: 43px;
			height: 100%;
			position: absolute;
			background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0, 0, 0, 0) 100%);
			z-index: 2;
			left: -1px;
		}
		.carousel-gradient-end {
			width: 43px;
			height: 100%;
			position: absolute;
			right: -1px;
			background: linear-gradient(270deg, rgba(0,0,0,1) 0%, rgba(0, 0, 0, 0) 100%);
			z-index: 2;
		}
		@media (max-width: 1537px) {
			/deep/ .VueCarousel-navigation-button {
				z-index: 3;
				&.VueCarousel-navigation-next {
					right: 35px;
				}
				&.VueCarousel-navigation-prev {
					left: 35px;
				}
			}
		}
	}
</style>
